var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calculate",
    "data-name": "Calculate",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      #calculate rect {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      #calculate rect, #calculate line, #calculate path {\r\n        fill: none;\r\n        stroke: currentColor;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      #calculate line {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.19,5.4v8.6s0,9.11,0,9.11c0,.24.25.49.5.49h12.75c.25,0,.5-.24.5-.49V4.89c0-.24-.25-.49-.5-.49H7.69c-.25,0-.5.24-.5.49v.73"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 12.62,
    y1: 14.77,
    x2: 15.5,
    y2: 14.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.62,
    y1: 17.8,
    x2: 15.5,
    y2: 17.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.62,
    y1: 20.84,
    x2: 15.5,
    y2: 20.84
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3,
    y1: 14.77,
    x2: 19.18,
    y2: 14.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3,
    y1: 17.8,
    x2: 19.18,
    y2: 17.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.3,
    y1: 20.84,
    x2: 19.18,
    y2: 20.84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.92,
    y: 7.06,
    width: 8.27,
    height: 4.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8.94,
    y1: 14.77,
    x2: 11.82,
    y2: 14.77
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.94,
    y1: 17.8,
    x2: 11.82,
    y2: 17.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.94,
    y1: 20.84,
    x2: 11.82,
    y2: 20.84
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculate);
export default __webpack_public_path__ + "static/media/calculate.35dbc468935dab7d4ccd3cbef040960e.svg";
export { ForwardRef as ReactComponent };